import {
  GridColumnMenuFilter
} from "@progress/kendo-react-grid";
import React, { Component } from "react";
  
  export default class ColumnMenuFilter extends Component {
   
    componentDidMount() {
        this.getSelectedColumn();
      }
   
      getSelectedColumn = () => {
        let col=this.props.column.field;
        this.props.getSelectedColumn(col);
    }
    render() {
      return (
        <div className="risksFilter" style={{color:'white'}}>
          {/* <GridColumnMenuSort {...this.props} /> */}
          <GridColumnMenuFilter {...this.props}  expanded={true}  />
        </div>
      );
    }
  }
  